'use strict';
/*
* main slider
* @package krobot
* @deps swiper
*/

const mySwiper = new Swiper ('.swiper-container', { // eslint-disable-line
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	centeredSlides: true,
	slidesPerView: 1,
	spaceBetween: 0,
	speed: 400,
	loop: true,
	loopAdditionalSlides: 1,
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	a11y: {
		prevSlideMessage: 'Previous slide',
		nextSlideMessage: 'Next slide',
	},
} );
